<template>
  <div>
    <div v-click-outside="onClickOutside">
      <el-row class="full-width">
        <el-col :xs="24">
          <div class="tee-time-container full-width">
            <el-form
              ref="ruleForm"
              :rules="rules"
              :model="formRequest"
              class="demo-ruleForm"
            >
              <el-row>
                <el-col :sm="24" :md="24">
                  <div
                    @click="handleShowDialogSearchFacility"
                    class="form-item mb-25"
                  >
                    <img
                      style="width: 18px;"
                      class="ml-10"
                      :src="bg.icon_address"
                      alt=""
                    />
                    <div
                      style="position: relative;"
                      class="full-width"
                      :class="{ 'is-action': formRequest.sub_title }"
                    >
                      <el-autocomplete
                        tabindex="-1"
                        ref="noFocusAutocomplete"
                        :value="formRequest.sub_title"
                        class="full-width el-select-add"
                        :trigger-on-focus="false"
                        @focus="preventFocus('noFocusAutocomplete')"
                        placeholder=" "
                      >
                      </el-autocomplete>
                    </div>
                    <label
                      :class="{ 'label-action': formRequest.sub_title }"
                      for="name"
                      >{{ $t("field") }}</label
                    >
                    <img class="mr-10" :src="bg.icon_arrow_input" alt="" />
                  </div>
                  <div class="form-item mb-25" style="padding:8px 0">
                    <img
                      style="width: 18px;"
                      class="ml-10"
                      :src="bg.icon_time"
                      alt=""
                    />
                    <datetime
                      :class="{ 'is-action': formRequest.date_played }"
                      class="theme-xanh full-width ml-10"
                      v-model="formRequest.date_played"
                      input-style="custom-input"
                      format="HH:mm dd-MM-yyyy"
                      type="datetime"
                      placeholder=" "
                      :min-datetime="minDate"
                      input-class="custom-datetime"
                      :phrases="{
                        ok: $t('confirm'),
                        cancel: $t('wap.text42')
                      }"
                    >
                    </datetime>
                    <label
                      :class="{ 'label-action': formRequest.date_played }"
                      for="name"
                      >{{ $t("timeRequired") }}</label
                    >
                    <img class="mr-10" :src="bg.icon_arrow_input" alt="" />
                  </div>
                  <div @click="handleShowAddMember" class="form-item mb-25">
                    <img
                      style="width: 18px;"
                      class="ml-10"
                      :src="bg.icon_user"
                      alt=""
                    />
                    <div
                      style="position: relative;"
                      class="full-width"
                      :class="{ 'is-action': getTextUser }"
                    >
                      <el-autocomplete
                        tabindex="-1"
                        ref="noFocusAutocomplete1"
                        :value="getTextUser"
                        class="full-width el-select-add"
                        :trigger-on-focus="false"
                        @focus="preventFocus('noFocusAutocomplete1')"
                        placeholder=" "
                      >
                      </el-autocomplete>
                    </div>
                    <label
                      :class="{ 'label-action': getTextUser }"
                      for="name"
                      >{{ `${$t("addUser")} (*)` }}</label
                    >

                    <img class="mr-10" :src="bg.icon_arrow_input" alt="" />
                  </div>
                  <div
                    v-if="
                    ![SOURCE_BANK.BIDV].includes(
                      parseInt(getToken().bank_id)
                    )
                    "
                    @click="isShowDialogPackage = true"
                    class="form-item mb-25"
                  >
                    <img
                      style="width: 18px;"
                      class="ml-10"
                      src="@/assets/img/v3/icon/icon_hio_wghn.svg"
                      alt=""
                    />
                    <div
                      style="position: relative;"
                      class="full-width"
                      :class="{ 'is-action': formRequest.package_name }"
                    >
                      <el-autocomplete
                        tabindex="-1"
                        ref="noFocusAutocomplete2"
                        :value="formRequest.package_name"
                        class="full-width el-select-add"
                        :trigger-on-focus="false"
                        @focus="preventFocus('noFocusAutocomplete2')"
                        placeholder=" "
                      >
                      </el-autocomplete>
                    </div>
                    <label
                      style="line-height: 15px;"
                      :class="{ 'label-action': formRequest.package_name }"
                      for="name"
                      >{{ $t("wap.text149") }}</label
                    >
                    <img class="mr-10" :src="bg.icon_arrow_input" alt="" />
                  </div>
                </el-col>
              </el-row>
            </el-form>
            <div class="mb-25">
              <AlertComponent
                v-if="!formRequest.facility_id || !formRequest.date_played"
                :text="$t('noti')"
                type="alert-warning"
                :icon="require('@/assets/img/v3/icon/_warning.svg')"
              />
              <AlertComponent
                v-else
                :text="`${$t('noti1')} ${estimatedPrice} ${$t('noti2')}`"
                type="alert-success"
                :icon="require('@/assets/img/v3/icon/_successful.svg')"
              />
            </div>
            <div
              class="btn-booking-history full-width m-0 flex justify-content-center"
            >
              <el-button
                :disabled="checkDisableForm(formRequest)"
                :loading="loadingSubmit"
                @click="handleSubmit"
                :class="[
                  checkDisableForm(formRequest)
                    ? 'btn-submit-disabled'
                    : 'c-white-text'
                ]"
                class="btn-submit fw-600 full-width"
                >{{ $t("reserveYourYardNow") }}</el-button
              >
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="dialog-container">
      <DialogSearchFacility
        @item-facility="handleFacility"
        @close="handleCloseDialog"
        :is-show-dialog="isShowDialog"
      />
      <DialogAddMember
        @item-facility="handleFacility"
        @close="isShowDialogAddMember = false"
        :is-show-dialog="isShowDialogAddMember"
      />
      <DialogPackage
        @item-ins="chooseIns"
        @close="isShowDialogPackage = false"
        :is-show-dialog="isShowDialogPackage"
      />
      <DialogNotify
        @close="handleCloseDialogNoti"
        :message="messageNoti"
        :is-show-dialog="isShowDialogNoti"
      />
    </div>
  </div>
</template>

<script>
import { isEmpty } from "@/utils/validate";
import DialogSearchFacility from "../facility/DialogSearchFacility.vue";
import DialogAddMember from "../addMember/Dialog.vue";
import DialogPackage from "@/components/popup/Insurance.vue";
import DialogNotify from "@/components/popup/Notify.vue";
import TeeTimeResource from "@/views/api/wapV2/tee-time.js";
import HomeRequest from "@/views/api/wapV2/homepage";
import { DateTime, Settings } from "luxon";
import moment from "moment";
import { SOURCE_BANK } from "@/constant/contant";
import AlertComponent from "@/components/Alert";
import { mapGetters, mapActions } from "vuex";
import { getInfo, getToken, getBackGround, getLanguage } from "@/utils/wapAuth";
Settings.defaultLocale = getLanguage() || "vi";

export default {
  components: {
    DialogSearchFacility,
    AlertComponent,
    DialogAddMember,
    DialogPackage,
    DialogNotify
  },
  bodyClass: "home-booking-page",

  created() {},
  data() {
    return {
      minDate: DateTime.now().toISODate(),
      SOURCE_BANK: SOURCE_BANK,
      loadingSubmit: false,
      loadingSearchFacility: false,
      isShowDialog: false,
      isShowDialogAddMember: false,
      isShowDialogPackage: false,
      isShowDialogNoti: false,
      msgNoti: "",
      estimatedPrice: null,
      formRequest: {
        date_played: "",
        facility_id: ""
      },
      list_insurance: [],
      rules: {},
      infoHeader: {
        title: this.$t("quickBookField"),
        isShowHomeIcon: true
      },
      bg: getBackGround(),
      active: true
    };
  },
  computed: {
    ...mapGetters(["list_golfer", "list_golfer_out"]),
    messageNoti() {
      const text = `${this.$t("wap.text173")}<br />
        <p style="text-align: justify;">
          ${this.$t("thankYouForBooking")}<br />
          ${this.$t("contactToConfirmBooking")}<br />
          ${this.$t("encounterBookingIssues")}<br />
          <b>${this.$t("contactNumber")} </b> 
        </p>
      `;
      return text;
    },
    getTextUser() {
      const info = getToken();
      const listUsers = this.list_golfer;
      const isByYou = listUsers.some(i => i.user_id == info.vga);
      const listOut = this.list_golfer_out || [];
      const dataTotal = [...listUsers, ...listOut];
      const total = dataTotal.length;

      if (total < 1) {
        return null;
      }
      if (total == 1 && isByYou) {
        return this.$t("wap.text153");
      }
      let totalText = `${this.$t("wap.text157")} ${total} pax:`;
      const userFirst = dataTotal.find(i => i.user_id != info.vga);
      if (total == 1 && !isByYou) {
        return `${totalText} ${userFirst.fullname}`;
      }
      if (total > 1) {
        if (isByYou) {
          totalText = `${totalText} ${this.$t("wap.text154")}, ${
            userFirst.fullname
          }`;
        } else {
          totalText = `${totalText} ${userFirst.fullname}, ${dataTotal[1].fullname}`;
        }
        if (total > 2) {
          totalText = `${totalText} ${this.$t("wap.text155")} ${total -
            2} ${this.$t("wap.text156")}`;
        }
        return totalText;
      }

      return null;
    }
  },
  watch: {
    // Theo dõi sự thay đổi của facility_id và date_played trong formRequest
    "formRequest.facility_id": "autoFetchPriceEstimate",
    "formRequest.date_played": "autoFetchPriceEstimate",
    "$store.getters.isShowSearchFacility": function(newValue) {
      if (newValue) {
        this.handleShowDialogSearchFacility();
      }
    },
    "$store.getters.isReRenderComponent": function(newValue) {
      if (newValue > 1 && !isEmpty(getToken().vga)) {
        this.add_golfer_default();
      }
    }
  },
  mounted() {
    if (getToken().vga) {
      this.add_golfer_default();
    }
    this.$refs.noFocusAutocomplete.$el.querySelector("input").blur(); // Đảm bảo rằng input không nhận focus khi component được mount
  },
  methods: {
    getToken,
    ...mapActions(["add_golfer_default"]),
    handleCloseDialogNoti() {
      this.isShowDialogNoti = false;
      this.$router.push(`/wap/history`);
    },
    chooseIns(val) {
      const arr = val.map(i => i.name);
      if (arr.length > 1) {
        this.formRequest.package_name = arr.join(" + ");
      } else if (arr.length == 1) {
        this.formRequest.package_name = `${val[0].name}`;
      } else {
        this.formRequest.package_name = "";
      }
      this.list_insurance = val.map(i => ({ product_id: i.id }));
    },
    handleCloseDialog() {
      this.isShowDialog = false;
      this.$store.dispatch("show_dialog_search_facility", false);
    },
    preventFocus(refName) {
      this.$refs[refName].$el?.querySelector("input").blur();
    },
    handleShowDialogSearchFacility() {
      this.isShowDialog = true;
    },
    handleShowAddMember() {
      if (!getInfo()) {
        this.$store.dispatch("showLoginDialog");
        return;
      }
      this.isShowDialogAddMember = true;
    },
    handleFacility(item) {
      if (item) {
        this.formRequest = {
          ...this.formRequest,
          sub_title: item.label,
          facility_id: item.value
        };
        this.handleCloseDialog();
      }
    },
    handleMessage() {
      location.href = "https://zalo.me/wbooking";
    },
    handleCall() {
      window.location.href = "tel:02471001088";
    },
    autoFetchPriceEstimate() {
      // Kiểm tra điều kiện trước khi gọi API
      if (this.formRequest.facility_id) {
        this.fetchPriceEstimate();
      }
    },
    fetchPriceEstimate() {
      let date_played =
        moment()
          .startOf("day")
          .unix() * 1000;
      if (this.formRequest.date_played) {
        date_played = new Date(this.formRequest.date_played).getTime();
      }
      const params = {
        facility_id: this.formRequest.facility_id,
        date_played
      };
      HomeRequest.listPriceBooking(params)
        .then(response => {
          if (response.error === 0) {
            const prices = response.data
              .map(item => item.price)
              .filter(i => i > 0);
            this.estimatedPrice = Math.min(...prices).toLocaleString("vi-VN");
          } else {
            this.$message.error("Không thể lấy giá. Vui lòng thử lại.");
          }
        })
        .catch(error => {
          console.error("API error:", error);
          this.$message.error("Lỗi kết nối. Vui lòng thử lại sau.");
        });
    },
    async handleSubmit() {
      if (!getInfo()) {
        this.$store.dispatch("showLoginDialog");
        return;
      }
      const mess = await this.validateFrom(this.formRequest);
      if (mess) {
        this.$message.warning(mess);
        return;
      }
      const list_users = [...this.list_golfer, ...this.list_golfer_out].map(
        i => ({
          user_id: i.user_id,
          name_out_system: i.fullname,
          list_insurrance: this.list_insurance
        })
      );
      let date_played =
        moment()
          .startOf("day")
          .unix() * 1000;
      if (this.formRequest.date_played) {
        date_played = new Date(this.formRequest.date_played).getTime();
      }
      const bodyForm = {
        list_users,
        date_played,
        facility_id: this.formRequest.facility_id
      };
      console.log("bodyForm__________", bodyForm);

      TeeTimeResource.create_booking_for_wap(bodyForm).then(res => {
        const { error_code, error_msg } = res;
        if (error_code != 0) {
          this.$message.warning(error_msg);
          return;
        }
        this.isShowDialogNoti = true;
        // this.$message.success("Đặt sân thành công.");
      });
    },
    onClickOutside() {
      this.active = false;
    },
    async validateFrom(obj) {
      let message = null;
      const body = {
        facility_id: obj.facility_id,
        date_played: obj.date_played
      };
      for (const key in body) {
        if (isEmpty(obj[key].toString())) {
          message = this.$t("pleaseFillInAllInformation");
          break;
        }
      }
      const list_user = [...this.list_golfer, ...this.list_golfer_out];
      if (list_user.length < 1) {
        message = this.$t("pleaseFillInAllInformation");
      }
      return message;
    },
    checkDisableForm(obj) {
      let result = false;
      const body = {
        facility_id: obj.facility_id,
        date_played: obj.date_played
      };
      for (const key in body) {
        if (isEmpty(obj[key].toString())) {
          result = true;
          break;
        }
      }
      const list_user = [...this.list_golfer, ...this.list_golfer_out];
      if (list_user.length < 1) {
        return true;
      }
      return result;
    }
  }
};
</script>
<style>
.form-item .el-input__inner {
  font-weight: 500;
  background-color: transparent;
  padding-left: 10px;
  font-size: v-bind("bg.fs_input") !important;
}
.form-item input::placeholder {
  color: v-bind("bg.c_placeholder") !important;
  font-size: v-bind("bg.fs_input") !important;
}
.theme-xanh .vdatetime-calendar__month__day--selected > span > span,
.theme-xanh .vdatetime-calendar__month__day--selected:hover > span > span {
  background: v-bind("bg.c_background3") !important;
}
.theme-xanh .vdatetime-popup__header {
  background: v-bind("bg.colorMain") !important;
}
.vdatetime-popup {
  font-family: v-bind("bg.font") !important;
}
.theme-xanh .vdatetime-year-picker__item--selected,
.theme-xanh .vdatetime-time-picker__item--selected,
.theme-xanh .vdatetime-popup__actions__button {
  color: v-bind("bg.colorMain") !important;
}
.theme-xanh input {
  width: 100% !important;
  font-weight: 500;

  font-size: v-bind("bg.fs_input") !important;
  color: v-bind("bg.c_input") !important;
}
.theme-xanh input::placeholder {
  color: v-bind("bg.c_placeholder") !important;
  font-size: v-bind("bg.fs_input") !important;
}
.el-date-picker {
  width: 350px !important;
  left: 15px !important;
}
.el-date-picker .el-picker-panel__content {
  width: 330px !important;
}
.el-date-picker .el-picker-panel__content .el-date-table {
  font-size: 18px !important;
}
.el-date-picker .el-picker-panel__content .el-month-table {
  font-size: 18px !important;
}
.el-date-picker .el-picker-panel__content .el-year-table {
  font-size: 18px !important;
}
.el-date-picker .el-picker-panel__content .el-date-table td span {
  width: 27px !important;
  height: 25px !important;
}

.el-date-picker__header-label {
  font-size: 18px !important;
}
.el-select-add .el-input input {
  color: v-bind("bg.c_input") !important;
  border: none;
  border-radius: 8px;
}
.el-select-add .el-input input:focus .label-facility {
  margin-left: 10px;
  position: absolute;
  z-index: 1000;
  top: 0px !important;
}
.el-date-picker-add input {
  padding: 0 0 0 10px !important;
  border: none;
  border-radius: 8px;
  color: red !important;
}
</style>

<style scoped lang="scss">
.btn-submit-disabled {
  background-color: #dcdcdc !important;
  color: #959595;
}

.form-item {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  border: 0.87px solid v-bind("bg.c_border3");
  border-radius: v-bind("bg.b_radius1");
  height: 48.90697479248047px;
  .is-action {
    padding-top: 10px;
  }
  label {
    position: absolute;
    margin-right: 20px;

    top: 50%;
    left: 36px;
    transform: translateY(-50%);
    font-size: 12px;
    color: v-bind("bg.c_placeholder") !important;
    transition: all 0.3s ease;
    pointer-events: none; // Không làm ảnh hưởng khi click vào
  }
  .label-action {
    top: 35%;
    font-size: 9px;
  }
}
.btn-submit {
  background: v-bind("bg.c_background4");
  text-transform: uppercase;
  font-weight: 600;
  border-radius: v-bind("bg.b_radius1");
  border: none;
  span {
    font-size: v-bind("bg.fs_input") !important;
  }
}
.btn-submit:hover {
  background: v-bind("bg.c_background4");
}
.time-container {
  margin: 0 !important;
  padding: 6px 0;
  border-radius: 8px;
  margin-bottom: 10px !important;
}
.btn-time-tee {
  font-size: 14px;
  border: none;
  color: #8f8f8f;
}
.col-tee-action {
  border-bottom: 2px solid v-bind("bg.c_border2");
}

.content-voucher {
  color: black;
}
.btn-history {
  height: 40px;
  width: 60%;
  border: 1px solid v-bind("bg.c_text_main");
  background: #fff;
  color: v-bind("bg.c_text_main");
}
.text-time {
  margin: 0;
  color: black;
  font-weight: 500;
}
.tee-time-container {
  padding: 25px 15px;
  background: #ffff;
  border: 1px solid rgba(226, 226, 226, 1);
  border-radius: v-bind("bg.b_radius2");
  min-height: 340px;
  margin: auto;
}
.w-260 {
  width: 265px;
}

.flex-grow {
  flex-grow: 1;
}

.pb-80 {
  padding-bottom: 80px;
}
.mt-36 {
  margin-top: 36px;
}
@media screen and (min-width: 0px) and (max-width: 769px) {
  .title-h3 {
    font-size: 18px;
  }

  .mt-8 {
    margin-top: 8px;
  }
}
</style>

<style lang="scss">
$divider-color: #d9d9d9;
.divider-view {
  height: 15px;
  width: 100%;
  background-color: $divider-color;
}
.divider-view-top {
  height: 15px;
  width: 100%;
}
.column {
  flex-direction: column;
}
.desktop {
  display: block;
}
.mobile {
  display: none;
}
.uppercase {
  text-transform: uppercase;
}
.full-width {
  width: 100%;
}

@media screen and (min-width: 0px) and (max-width: 480px) {
  .title-h3 {
    font-size: 14px !important;
  }

  .text-time {
    font-size: 13px;
  }

  .desktop {
    display: none;
  }
  .mobile {
    display: block;
  }
}

@media screen and (min-width: 0px) and (max-width: 769px) {
  .desktop {
    display: none;
  }
  .mobile {
    display: block;
  }
}
</style>
